const CompanyTypes = {
    Company_ACTION_START:"Company_ACTION_START",
    Company_FETCH_DATA:"Company_FETCH_DATA",
    Company_FETCH_DATA_FAILED:"Company_FETCH_DATA_FAILED",
    Company_ADD_DATA:"Company_ADD_DATA",
    Company_DELETE_DATA:"Company_DELETE_DATA",
    Company_UPDATE_DATA:"Company_UPDATE_DATA",
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
}

const CompanyReducer = (state=Initial_state, action) => {
    switch(action.type){
        case CompanyTypes.Company_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case CompanyTypes.Company_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload,
            }

        case CompanyTypes.Company_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }
        default:
            return state;
    }
};

export default CompanyReducer;